import React from "react";
import {
    Row,
    Col,
    Space,
    Image,
    Tooltip,
    Select,
    Modal,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";
import withRouter from "../withRouter";
import CompanyStore from "../store/CompanyStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ParentStore from "../store/ParentStore";
const { Option } = Select;

class ParentComplaintList extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.companyStore = new CompanyStore(this);
        this.parentstore = new ParentStore(this);

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            loadData: 1,
            companyId: "",
            comp_value: "",
            listDataUpdate: false,
            openStudentRouteForm: false,
            openDeleteModal: false,
            deleteData: {},
            previewVisible: false,
            previewImage: "",
        };

        this.columns = [
            {
                title: context.translate("_PARENT_NAME_"),
                dataIndex: "parentName",
                width: 70,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_COMPLAINT_DESCRIPTION_"),
                dataIndex: "complainDesc",
                width: 70,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_PROOF_"),
                dataIndex: "proof",
                width: 70,
                ellipsis: { showTitle: true },

                render: (text) => {

                    return text ? (
                        // <img
                        //     src={"https://sa.trackeazy.com/api/public/fleet/images/students/" + text}
                        //     alt="proof"
                        //     style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 4 }}
                        // />
                        <Image
                            src={"https://sa.trackeazy.com/api/public/fleet/images/students/" + text}
                            width={50}
                            height={50}
                            style={{ objectFit: "cover", cursor: "pointer" }}
                            preview={{
                                visible: undefined, // let AntD control
                            }}
                            onClick={(e) => {
                                e.stopPropagation(); // important (table row issue)
                                this.setState({
                                    previewVisible: true,
                                    previewImage: "https://sa.trackeazy.com/api/public/fleet/images/students/" + text,
                                });
                            }}
                        />
                    ) : (
                        "-"
                    );
                },
            },
            {
                title: context.translate("_COMPLAINT_STATUS_"),
                dataIndex: "complaintStatus",
                width: 30,
                align: "center",
                ellipsis: { showTitle: true },

                render: (_, record) => {
                    const value = record.complaintStatus ?? 1;
                    const statusList = this.parentstore.complainStatusList || [];
                    return (
                        <Space>
                            <Select
                                value={value}
                                style={{ width: 140 }}
                                onChange={(value) => this.handleStatusChange(value, record)}
                            >
                                {statusList.map((item) => (
                                    <Select.Option key={item.Id} value={item.Id}>
                                        {item.complaintStatus}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Space>
                    );
                },
            },
        ];
    }
    async componentDidMount() {
        await this.parentstore.getComplaintStatusList();
        if (
            Number(this.props.getUserData().isadmin) !== -1 ||
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.handleSearch();
            this.setState({ pageSize: 50, loadData: 1 });
        }
    }
    async handleStatusChange(value, record) {
        var postData = {
            Id: record.Id,
            complaintStatus: value,
        };
        const response = await this.parentstore.updateComplaintStatus(postData);
        this.handleSearch();
    }

    async handleSearch() {
        this.setState({ loading: true });
        const data = {
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            companyId: this.state.companyId,
        }
        await this.parentstore.getParentComplaints(data);
        await this.setState({ loadData: 1, loading: false });
    }

    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        await this.handleSearch();
    }

    refreshList = async () => {
        this.setState({ loading: true });
        await this.parentstore.getParentComplaints({
            offset: 0,
            limit: 50,
            companyId: this.state.companyId,
        });
        this.setState({ loading: false, currentPage: 1 });
    };
    async handleChange(comp) {
        await this.setState({
            companyId: comp.value,
            currentPage: 1,
            pageSize: 50,
        });
        const singleData = await this.companyStore.getCompanyDataById(comp.value);
        await this.setState({ company_value_label: singleData });
        await this.handleSearch();
    }

    render() {
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    value={
                                        this.state.company_value_label
                                            ? this.state.company_value_label
                                            : null
                                    }
                                    onChange={(value) => this.handleChange(value)}
                                    style={{ width: 200 }}
                                />
                            </Space>
                        </Col>
                        <Col
                            span={8}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Tooltip
                                title={this.context.translate("_REFRESH_")}
                                placement="bottom"
                            >
                                <Image
                                    style={{
                                        height: 18,
                                        alignItems: "center",
                                        cursor: "pointer",
                                        marginInlineEnd: "20px",
                                    }}
                                    src={refreshIcon}
                                    onClick={() => this.refreshList()}
                                ></Image>
                            </Tooltip>

                        </Col>
                    </Row>
                    <ListTable
                        currentPage={this.state.currentPage}
                        total={this.parentstore?.total}
                        columns={this.columns}
                        pageSize={this.state.pageSize}
                        dataSource={this.parentstore?.parentComplaintlist}
                        loading={this.parentstore?.loading}
                        onChange={this.handleTableChange}
                    />
                </div>

                <Modal
                    open={this.state.previewVisible}
                    footer={null}
                    onCancel={() => this.setState({ previewVisible: false })}
                    centered
                    width={600}
                    bodyStyle={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "60vh",
                    }}
                >
                    <img
                        alt="preview"
                        src={this.state.previewImage}
                        style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                        }}
                    />
                </Modal>

            </>
        );
    }
}
ParentComplaintList.contextType = StoreContext;
export default observer(withRouter(ParentComplaintList));
